import { Text } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
`;

const ItemTitle = styled(Text)`
    font-family: CeraProBold, arial, sans-serif;
`;

export { Container, ItemTitle };
